import { render, staticRenderFns } from "./ProductNotPrintableMonitor.vue?vue&type=template&id=51da80a5"
import script from "./ProductNotPrintableMonitor.vue?vue&type=script&lang=ts"
export * from "./ProductNotPrintableMonitor.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports